<div id="canvasContainer">
  <canvas id="fabricCanvas"></canvas>
</div>




// WEBPACK FOOTER //
// ./src/app/detection/canvas-imageprocessing/canvas-imageprocessing.component.html